titles:
  welcomeBack: Welkom terug
  otp: Vul je inlogcode in
  welcome: Welkom
messages:
  login: Log in om door te gaan
  passwordReset: Vul hieronder een sterk wachtwoord in
  passwordForgotten: Vraag een email aan om uw wachtwoord te herstellen.
  forgotYourPassword: Uw wachtwoord vergeten?
  passwordResetMailSend: Als je e-mailadres bij ons bekend is, ontvang je zo een e-mail van ons. Klik op de link in die e-mail om een nieuw wachtwoord in te stellen.
  passwordHasBeenReset: Uw wachtwoord is opnieuw ingesteld. U kunt nu inloggen met uw nieuwe wachtwoord.
  noAccount: Nog geen account?
  startFreeTrail: Start je gratis proefperiode →
  errorInvalidCode: Ongeldige code. Probeer het opnieuw.
  codeRequired: We hebben een code van 6 cijfers gemaild naar {email}.
  checks:
    use8Characters: Gebruik minstens 8 tekens
    useAtLeast1Number: Gebruik minstens 1 cijfer
    useAtLeast1SpecialCharacter: Gebruik minstens 1 speciaal symbool
    passwordsDontMatch: Wachtwoorden komen overeen
actions:
  login: Inloggen
  passwordReset: Wachtwoord instellen
  submit: Verzenden
  resend: Opnieuw versturen
fields:
  email: E-mailadres
  password: Wachtwoord
  passwordConfirmation: Herhaal wachtwoord
  code: Code
